import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from "react-hook-form";
import {
  Textarea,
  type ITextareaProps,
} from "@components/inputs/Textarea/Textarea";

type TFormInputProps<T extends FieldValues> = ITextareaProps &
  UseControllerProps<T>;

export const FormTextarea = <T extends FieldValues>({
  name,
  control,
  ...rest
}: TFormInputProps<T>) => {
  const controller = useController({
    name,
    control,
  });

  const {
    field,
    fieldState: { error },
  } = controller;

  const { ref: fieldRef, ...fieldRest } = field;

  return (
    <Textarea
      {...rest}
      {...fieldRest}
      ref={fieldRef}
      error={error?.message}
      {...(rest.disabled ? { disabled: true } : {})}
    />
  );
};
